import { Typography, Divider } from "@mui/material";
import {
  NoteWrapper,
  RiskItem,
  RiskLabel,
  SubSectionTitle,
  useSpContext,
} from "components/summary/success-plan";
import styles from "../SuccessPlan.module.scss";
import moment from "moment-timezone";

type WorkloadAssessmentViewProps = {
  fieldName: string;
  title: string;
  wemLbl: string;
  histories: any[];
  riskValue: string | null;
  riskNote: string | null;
  wemValue: string | null;
  addDivider?: boolean;
};

const WorkloadAssessmentView = ({
  fieldName,
  title,
  wemLbl,
  histories,
  riskValue,
  riskNote,
  wemValue,
  addDivider = true,
}: WorkloadAssessmentViewProps) => {
  const { riskItems, coverageStatusItems } = useSpContext();

  const riskItem: RiskItem | undefined = riskItems.find((item) => item.value === riskValue);

  const filteredHistories = histories.filter((history: any) => history.fieldName === fieldName);

  const noteHistories = filteredHistories.slice(1);
  const lastUpdatedOn =
    filteredHistories.length > 0
      ? moment(filteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  const wemLblColor = coverageStatusItems.find((c) => c.label === wemValue)?.color ?? undefined;

  return (
    <>
      <SubSectionTitle title={title} />
      <div className={styles["sp-flex-horizontal"]}>
        <Typography className={styles["sp-label-gray"]}>{wemLbl}:</Typography>
        <Typography
          className={styles["sp-label"]}
          style={{ color: wemLblColor }}
        >
          {wemValue}
        </Typography>
      </div>
      <RiskLabel riskItem={riskItem} />
      <NoteWrapper
        riskNote={riskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
      {addDivider && <Divider />}
    </>
  );
};

/* 
type WorkloadAssessmentViewProps = {
  title: string;
  wemLbl: string;
  wemValue: string | null;
  wemLblColor: any;
  riskItem: RiskItem | undefined;
  riskNote: string | null;  
  noteHistories: any[];
  lastUpdatedOn?: string;
  addDivider?: boolean;
};

const WorkloadAssessmentView = ({
  title,
  wemLbl,
  wemValue,
  wemLblColor,
  riskItem,
  riskNote,
  noteHistories,
  lastUpdatedOn = "N/A",
  addDivider = true,

}: WorkloadAssessmentViewProps) => {
  return (
    <>
      <SubSectionTitle title={title} />
      <div className={styles["sp-flex-horizontal"]}>
        <Typography className={styles["sp-label-gray"]}>
          {wemLbl}: 
        </Typography>
        <Typography className={styles["sp-label"]} style={{ color: wemLblColor }}>
          {wemValue}
        </Typography>
      </div>
      <RiskLabel riskItem={riskItem} />
      <NoteWrapper
        riskNote={riskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
      {addDivider && <Divider />}
    </>
  );
}; */

export default WorkloadAssessmentView;
